import { Block } from "@material-ui/icons";
import { createTheme } from "@mui/material/styles";
import { height } from "@mui/system";
import { padding, width } from "@mui/system";

const muiThemeDesign = createTheme({
    palette: {
        primary: {
            main: "#1976d2",
        },
        secondary: {
            main: "#ffffff",
        },
    }, 

    MuiTypography: {
 //       root: {
 //           color:"#fffff"
 //       },
              h6: {
            color: "#000000"
              },
            reports: {
                width: 120,
                display: "flex",
                textAlign: "left",
            },

    },
    MuiSvgIcon: {
        secondary: {
            color: "#000000",
            fill: "#000000",
        },
        error: {
            color: "#c40018",
            fill: "#c40018",
        }
    },
 
    components:
    {
        MUIDataTableViewCol:
        {
            styleOverrides:
            {
                root:
                    { background: "#42a5f5!important"}
            }
        },
        MUIDataTable: {
            responsiveScroll: {
                maxHeight: 'unset',
                overflowX: 'unset',
                overflowY: 'unset',
            },
        },
        MuiToolbar: {
            root: {
                top: 0,
                position: 'sticky',
                background: 'white',
                zIndex: '100',
            },
        },
        MUIDataTableHeadCell: {
            fixedHeader: {
                top: '62px',
            },
        },
        MuiDataTableBodyCell: {
            root: {
                backgroundColor: "#FFFFFF",

            }
        },
    },
    overrides: {
        MuiList: {
            root: {
                height: 300,
                display: "flex",
                flexFlow: "column wrap",
                gap: 5,
                overflow: "auto",
                width: "100%"
            },
        },
            MuiDialog: {
                paper: {
                    overflowy: "auto",
  //                  overflowy: "hidden",
                },
            },
            MuiTable: {
                root: {
                    backgroundColor: "#FFFFFF",

                },
        },
        MuiTablePagination: {
            root: {
                color: "#ffffff",
                backgroundColor: "#1976d2"
            }

        },
            MuiPopover: {
                paper: {
                    minWidth: "500px",
                    maxWidth: "600px",
                    background: "#42a5f5"
                },
            },
            MuiPaper: {
      //          elevation4: {
      //              backgroundColor: "#1976d2",

       //         }, 
                root: {
                    overflowy: "hidden",
     //               color: "#ffffff"
                }
            },
            MuiDrawer: {
                backgroundColor: "#FFFFFF",
                color: "black"
            },
            MuiDataTable: {
                paper: {
                    overflowy: "hidden",
                    backgroundColor: "#FFFFFF",
                   
                },
            },
            MuiDataTableBodyCell: {
                root: {
                    backgroundColor: "#FFFFFF",

                }
            },
            MuiDataTableCell: {
                root: {
                    maxWidth: "280px",

                },
                footer: {
                    backgroundColor: "#1976d2",
                },

            },
            MuiTableCell: {
                footer: {
                    backgroundColor: "#1976d2",
                },

        },
            MUIDataTableFilter: {
               root: {
                    background: "#42a5f5",
                    backgroundColor: "#42a5f5"
                }
            },
            MuiBox: {
                root: {
                    paddingTop: 8,
                    paddingBottom: 8,
                    paddingLeft: 16,
                    paddingRight: 16,
                    display: Block,
                }
            },
            MuiListItemText: {
                root: {
                    display: "flex",
                    paddingLeft: 10,
                    width: 120,
                    alignItems: "center",
                }

            },
            MuiListItemIcon: {
                root: {
                    color: "#1f1b1e",

                }

            },
            MuiIconButton: {
                root: {
                    color: "#FFFFFF",

                }
            },
            MuiSelect: {
                root: {
                    height: "50px",
                    backgroundColor: "#bbdefb"
                },
                nativeInput: {
                    height: "50px",
                },

            },
            MuiInputBase: {
                input: {
                    backgroundColor: "#FFFFFF",
                    height: "30px",
                    padding: "5px 10px 5px",
                    color: "#1f1b1e",
                },
                root: {
                    height: "50px",
                },
                multiline: {
                    padding: "5px 10px 5px",
                },

            },
  /*          MuiFormControl: {

                multiline: {
                    paddingLeft: "0px",
                    paddingRight: "10px",
                    paddingTop: "5px",
                },
            }, */
            MuiFormControl: {
                root: {
                    paddingleft: "0px",
                //    paddingRight: "10px",
                    paddingTop: "0px",
                //    height: "75px",
                    width: "220px",
                    backgroundColor: "#42a5f5",
                },
            },
            MuiButtonBase: {
                root: {
                    paddingTop: 8,
                    paddingBottom: 8,
                    paddingLeft: 16,
                    paddingRight: 16,
            //        height: "75px",
            //        width: "220px",
                    display: Block,
          //          color: "#1f1b1e",
                }
            },
            MuiSvgIcon: {
                root: {
                    color: "#1f1b1e", 
                    colorPrimary: "#ffffff", 
                    //
                    fill: "#ffffff", 

                },
 /*               secondary: {
                    color: "#000000",
                    fill: "#000000",
                },
                error: {
                    color: "#c40018",
                    fill: "#c40018",
                }*/
            },
            MUIDataTableSelectCell: {
                icon: {
                    fill: "#1f1b1e",
                }
            },
            Mui: {
                checked: {
                    color: "#1f1b1e",
                    //
                    fill: "#ffffff",
                }
            },
            MuiCheckbox: {
                root: {
                    color: "#1f1b1e", 
                    colorPrimary: "#1f1b1e",
                    checked: "#1f1b1e",
                    fill: "#000000",
                    indeterminate: "#1f1b1e",
                },
            }, 
            MuiChip: {
            root: {
                    backgroundColor: "#42a5f5!important",
                    background: "#42a5f5!important",
                 },
            }, 
            PrivateSwitchBase: {
                root: {
                    color: "#1f1b1e", 
                    colorPrimary: "#1f1b1e",
                    checked: "#1f1b1e",
                    fill: "#000000",
                    indeterminate: "#1f1b1e",
                },

            },
            MuiPicker: {
                root: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    height: "100",
                    backgroundColor: "#3f51b5",

                },
                label: {
                    color: "#3f51b5"

                }
            },
            MuiToolbar: {
                root: {
                    backgroundColor: "#1976d2",
                    color: "#ffffff"
                },
                gutters: {
                    paddingBottom: "10px",
                    paddingTop: "5px"
                }
            },
            MuiMenuItem: {
                selected: {
                    backgroundColor: "#1f1b1e",
                }
            },
            MuiMenu: {
              list: {
                    backgroundColor: "#bbdefb",
              }
            }  
        }
});
  //////////////////////////////////////////////////////////
const muiThemePicker = createTheme({
    palette: {
        primary: {
            main: "#1976d2",
        },
        secondary: {
            main: "#f50057",
        },
    },
    overrides: {
        MuiBox: {
            root: {
                paddingTop: 8,
                paddingBottom: 8,
                paddingLeft: 16,
                paddingRight: 16,
                display: Block,
            }
        },
        MuiButtonBase: {
            root: {
                paddingTop: 8,
                paddingBottom: 8,
                paddingLeft: 16,
                paddingRight: 16,
                display: Block,
                //          color: "#1f1b1e",
            }
        },
        MuiPaper: {
            elevation4: {
                backgroundColor: "#1976d2",
            },
            elevation1: {
                backgroundColor: "#1976d2",
                boxShadow: 0,
            },
            rounded: {
                backgroundColor: "#ffffff",
            },
            root: {
                //
                color: "#000000"
            }
        },
        MuiFormControl: {
            root: {
                paddingleft: "0px",
                //    paddingRight: "10px",
                paddingTop: "0px",
                //     height: "75px",
                width: "220px",
                backgroundColor: "#FFFFFF",
            },
        },
        MuiButton: {
            root: {
                color: "#000000"
            },
            label: {
             color:"#000000",
                h4: { color: "#a650b3 !important" },
                h2: { color: "#a650b3 !important" },
            },
        },
        MuiDrawer: {
            backgroundColor: "#FFFFFF",
            color: "black"
        },
        MuiInput: {
            underline: {
                borderBottom: "0px"
            }
        },
        MuiInputBase: {
            input: {
                backgroundColor: "inherit",
                textAlign: "center",
                color: "#FFFFFF",
                height: "50px",
                width: "200px",
                borderRadius: "5",
                padding: "5px 10px 5px",
                fontSize: "x-large",
          //      border: "2px dashed",
                boxSizing: "border-box",
                boxShadow: 1,
            },
            root: {
                height: "50px",
                backgroundColor: "#1976d2",
            },
            multiline: {
                padding: "5px 10px 5px",
            },
        },
        MuiListItemText: {
            root: {
                display: "flex",
                paddingLeft: 10,
                width: 120,
                alignItems: "center",
            }

        },
        MuiListItemIcon: {
            root: {
                color: "#1f1b1e",

                }

        },
        MUIDataTableSelectCell: {
            icon: {
                fill: "#1f1b1e",
            }
        },
        MuiToolbar: {
            root: {
                backgroundColor: "#1976d2",
            },
            gutters: {
                paddingBottom: "10px",
                paddingTop: "5px"
            }
        },
        MuiPicker: {
            root: {
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                height: "100",
                backgroundColor: "#3f51b5",

            },
            label: {
                color: "#3f51b5"

            }
        },
        MuiPickerModel: {
            dialogRoot: {
                minWidth: "320",
            }
        },
        MuiPickersActionBar: {
            root: {
                color: "#3f51b5"
            },
        },
        MuiTypography: {
            h4: {
                color: "#ffffff !important"
            },
            h2: {
                color: "#ffffff !important"
            },
        },

    },
});
///////////////////////////////////////////////////////
const muiThemeDark = createTheme({
    palette: {
        primary: {
            main: "#1976d2",
        },
        secondary: {
            main: "#ffffff",
        },
    },
    overrides: {
        MuiBox: {
            root: {
                paddingTop: 8,
                paddingBottom: 8,
                paddingLeft: 16,
                paddingRight: 16,
                display: Block,
            }
        },
        MuiButton: {
            root: {
                color: "#000000"
            },
            label: {
                color: "#000000"
            }
        },
        MuiButtonBase: {
            root: {
                paddingTop: 8,
                paddingBottom: 8,
                paddingLeft: 16,
                paddingRight: 16,
                display: Block,
                //          color: "#1f1b1e",
            }
        },
        MUIDataTableSelectCell: {
            icon: {
                fill: "#1f1b1e",
            }
        },
        MuiFormControl: {
            root: {
                paddingleft: "0px",
            //    paddingRight: "10px",
                paddingTop: "0px",
           //     height: "75px",
                width: "220px",
                backgroundColor: "#FFFFFF",
            },
        },
        MuiListItemText: {
            root: {
                display: "flex",
                paddingLeft: 10,
             //   width: 120,
                alignItems: "center",
            }

        },
        MuiListItemIcon: {
            root: {
                color: "#1f1b1e",

                }

        },
        MuiInputBase: {
            input: {
                backgroundColor: "#FFFFFF",
                height: "30px",
                padding: "5px 10px 5px",
                color: "#1f1b1e",
            },
            root: {
                height: "50px",
            },
            multiline: {
                padding: "5px 10px 5px",
            },
        },
        MuiList: {
            root: {
                height: 300,
                display: "flex",
                flexFlow: "column wrap",
                gap: 5,
                overflow: "auto",
            },
        },
        MuiPaper: {
            elevation4: {
                backgroundColor: "#1976d2",
            },
            elevation1: {
                backgroundColor: "#1976d2"
            },
            rounded: {
                backgroundColor: "#ffffff",
            },
            root: {
                //
                color: "#000000"
            }
        },
        MuiSelect: {
            root: {
                height: "50px",
            },
            nativeInput: {
                height: "50px",
            },

        },
        MuiSvgIcon: {
            root: {
                color: "#1f1b1e",
                colorPrimary: "#1f1b1e",
                //
                fill: "#000000",
            },
        },
        MuiTable: {
            root: {
                //      color: "#1f1b1e",
                backgroundColor: "#ffffff",
                //
                //    fill: "#000000",
            },
        },
        MuiToolbar: {
            root: {
                backgroundColor: "#1976d2",
            },
            gutters: {
                paddingBottom: "10px",
                paddingTop: "5px"
            }
        },
        MuiTypography: {
            h6: {
                color: "#000000"
            },
            reports: {
                width: 120,
                display: "flex",
                textAlign: "left",
            },

        },
        MuiList: {
            root: {
                height: 300,
                display: "flex",
                flexFlow: "column wrap",
                gap: 5,
                overflow: "auto",
            },

        },




    },
});

export { muiThemeDesign };
export { muiThemePicker };
export { muiThemeDark };
